
function getStackingAgentMonth (data) {
  // let MonthLists = data.map(function (item) {
  //   let result = item.split('-')
  //   return getMonthNumber(result[1])
  // })
  let MonthLists = getMonthNumber()
  return MonthLists
}

function getStackingAgentLegend (data) {
  let GoodsName = []

  data.forEach(function (itemParent) {
    itemParent.forEach(function (item) {
      if (!GoodsName.includes(item.customerName)) {
        GoodsName.push(item.customerName)
      }
    })
  })
  return GoodsName
}
function getSeriesLists (data) {
  let seriesObjectLists = {}
  data.forEach(function (itemParent) {
    itemParent.sort((a, b) => a.totalPay - b.totalPay).forEach(function (item) {
      if (!seriesObjectLists[item.customerName]) {
        seriesObjectLists[item.customerName] = {
          name: item.customerName,
          type: 'bar',
          stack: '总量',
          data: [item.totalPay]
        }
      } else {
        seriesObjectLists[item.customerName].data.push(item.totalPay)
      }
    })
  })
  return Object.values(seriesObjectLists)
}
function initStackingData (data) {
  let enterprise = Object.keys(data)
  let valList = Object.values(data)
  return {
    MonthLists: getStackingAgentMonth(enterprise),
    legend: getStackingAgentLegend(valList),
    seriesData: getSeriesLists(valList)
  }
}

function getMonthNumber (data) {
  let Month = {
    '01': '一月',
    '02': '二月',
    '03': '三月',
    '04': '四月',
    '05': '五月',
    '06': '六月',
    '07': '七月',
    '08': '八月',
    '09': '九月',
    '10': '十月',
    '11': '十一月',
    '12': '十二月'
  }
  let preMonth = ['一月', '二月', '三月', '四月', '五月', '六月']
  let nextMonth = ['七月', '八月', '九月', '十月', '十一月', '十二月']
  let nowMonth = new Date().getMonth()
  return nowMonth > 5 ? nextMonth : preMonth
}

export function StackingAgentEchartOp ({ v, data }) {
  // 堆叠
  let options = {

    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      textStyle: {
        color: '#FFFFFF'
      },
      icon: 'circle'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [],
      nameTextStyle: { color: '#999' },
      axisLabel: {
        textStyle: {
          color: 'rgba(255,255,255,.6)'
        }
      }
    },
    yAxis: {
      name: '万元',
      type: 'value',
      nameTextStyle: { color: '#999' },
      axisLabel: {
        color: 'rgba(255,255,255,.6)',
        formatter: function (value) {
          return value / 10000
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,.6)'
        }
      },
      axisLine: {
        show: true
      }
    },
    series: [
      {
        name: '直接访问',
        type: 'bar',
        stack: '总量',
        data: [320, 302, 301, 334, 390, 330, 320]
      },
      {
        name: '邮件营销',
        type: 'bar',
        stack: '总量',
        data: [120, 132, 101, 134, 90, 230, 210]
      },
      {
        name: '联盟广告',
        type: 'bar',
        stack: '总量',
        data: [220, 182, 191, 234, 290, 330, 310]
      },
      {
        name: '视频广告',
        type: 'bar',
        stack: '总量',
        data: [150, 212, 201, 154, 190, 330, 410]
      },
      {
        name: '搜索引擎',
        type: 'bar',
        stack: '总量',
        data: [820, 832, 901, 934, 1290, 1330, 1320]
      }
    ]
  }
  let { MonthLists, legend, seriesData } = initStackingData(data)
  options.xAxis.data = MonthLists
  options.legend.data = legend
  options.series = seriesData
  return options
}
